<script>
import appStore from "@/src/state/appStore";
export default {
  components: {},
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isMenuOpened: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    menuItems() {
      // return [];
      return appStore.getters.subMenuItems;
    }
  },
  data() {
    return {};
  }
};
</script>

<template>
  <!-- Topbar Start -->
  <div class="topbar-menu">
    <div class="container-fluid">
      <b-collapse id="navigation" v-model="isMenuOpened">
        <!-- Navigation Menu-->
        <ul class="navigation-menu">
          <router-link
            tag="li"
            :to="item"
            class="has-submenu"
            :key="index"
            v-for="(item ,index) in menuItems"
          >
            <a>
              <!-- <i class="remixicon-key"></i> -->
              {{ $t(item.name) }}
            </a>
          </router-link>
        </ul>
        <!-- 
        <ol class="breadcrumb float-right">
          <li class="breadcrumb-item">
            <a href="#">Home</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#">Library</a>
          </li>
          <li class="breadcrumb-item active">Data</li>
        </ol>
        -->
        <div class="clearfix"></div>
      </b-collapse>
      <!-- end #navigation -->
    </div>
    <!-- end container -->
  </div>
  <!-- end navbar-custom -->
</template>

<style lang="scss"></style>
